
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTrackOffStrb as ObiTrackOffStrbElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-track-off-strb.js';
 
 
 

 
 export const ObiTrackOffStrb = createComponent({
   react: React,
   tagName: 'obi-track-off-strb',
   elementClass: ObiTrackOffStrbElement,
   events: {
     
   }
  });
 
 